import { IDataSet } from '../Track';
import { AdvertisementArea } from '../../SDK/Advertisement';
import { RewardType } from '../../Rewards/RewardType';

export enum AdContexts {
    LOSS_AVERSION = 'LOSS_AVERSION',
    WIN_SEQUENCE = 'WIN_SEQUENCE',
    FREE_PLAY = 'FREE_PLAY',
}

export enum AdType {
    INTERSTITIAL = 'INTERSTITIAL',
    REWARDED = 'REWARDED',
    REWARDED_CROSS_PROMO = 'REWARDED_CROSS_PROMO',
    FAKE_AD = 'FAKE_AD',
}

export enum AdName {}

export class AdDataSet implements IDataSet {
    public adType: AdType = undefined;
    public placementID: string = undefined;
    public adName: string = undefined;
    public adGameArea: AdvertisementArea = undefined;
    public adRewardType: RewardType = undefined;
    public adContext: AdContexts = undefined;
    public adID: string = undefined;
    public adAdvertisementArea: AdvertisementArea = undefined;
    public adError: string = undefined;
    public adLevelNum: number = undefined;
    public adSuccess: number = undefined;

    public adProvider: string = undefined;
    public adRequestTimeMs: number = undefined;
    public adSdkVersion: string = undefined;
    public adWaterfallIndex: number = 0;
}
